const convertTypes = {
    preferences: {

    },
    types : {
        sentence: {
            label: 'Sentence Format',
            value: 'sentence'
        },
        title: {
            label: 'Title Format',
            value: 'title'
        },
        uppercase: {
            label: 'UPPERCASE LETTER',
            value: 'uppercase'
        },
        lowercase: {
            label: 'lower case',
            value: 'lowercase'
        },
    }
}

export default convertTypes;


// WEBPACK FOOTER //
// ./src/config/convertTypes.js